import { SearchTerm } from "./SearchTerm";

const CertificatesSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "name",
        translationKey: "name"
    },
    {
        heading: "Type",
        accessor: "certType",
        searchOnName: "ksCertificateType.trnName",
        translationKey: "type"
    },
    {
        heading: "Status",
        accessor: "certStatus",
        searchOnName: "ksCertificateStatus.trnName",
        translationKey: "status"
    },
];

export default CertificatesSearch;
